import { useEffect } from "react";
import * as Scrivito from "scrivito";
import { Collapse } from "reactstrap";
import { useMobileNavigation } from "^/Context/MobileNavigationContext";
import getOrderedChildren from "^/utils/getOrderedChildren";
import NavigationList from "./NavigationList";

function filterChildren(children) {
  return children.filter((c) => c.get("hideInNavigation") !== "yes");
}

function MobileNavigation({ homepage, currentPage, show }) {
  const { navigationLevel, currentPageId, breadcrumb, dispatch } =
    useMobileNavigation();

  const parent = currentPageId
    ? Scrivito.Obj.onAllSites().get(currentPageId)
    : homepage;

  useEffect(() => {
    if (breadcrumb.slice(-1)[0] !== parent.id()) {
      dispatch({ type: "addToBreadcrumb", payload: parent.id() });
    }
  }, [breadcrumb, dispatch, parent]);

  const children = filterChildren(getOrderedChildren(parent));

  return (
    <Collapse isOpen={show} className="nav-levels">
      <NavigationList
        navigationLevel={navigationLevel}
        currentPage={currentPage}
        elems={children}
      />
    </Collapse>
  );
}
export default Scrivito.connect(MobileNavigation);
